import React from "react";
import {
  AppstoreOutlined,
  SoundOutlined,
  ShoppingOutlined,
  ApartmentOutlined,
  ShopOutlined,
  ApiOutlined,
  InboxOutlined,
  PieChartOutlined,
  BarChartOutlined,
  UserAddOutlined,
  DollarOutlined,
  ShoppingCartOutlined,
  TeamOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CompassOutlined,
  CustomerServiceOutlined,
  ClockCircleOutlined,
  SettingOutlined,
  LogoutOutlined,
  DownloadOutlined,
  StarOutlined,
  RiseOutlined,
  HomeOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  CarOutlined,
} from "@ant-design/icons";
import { MdCreditScore, MdElectricBike } from "react-icons/md";
import { BsBuildingGear, BsCashCoin } from "react-icons/bs";
import { FaRegHandshake, FaUsersGear } from "react-icons/fa6";
import { LiaTruckLoadingSolid } from "react-icons/lia";

// ---------------------------------------------------------------------------
// Menu definitions
//
// Each group has:
//   group:     string  — display label. Empty string = flat items (no submenu).
//   groupIcon: JSX     — icon shown on the collapsed submenu trigger.
//   items:     Array   — individual nav items.
// ---------------------------------------------------------------------------

export const AdminSideBarMenu = [
  // {
  //   group: "",
  //   groupIcon: <RiDashboardLine />,
  //   items: [
  //   ],
  // },
  {
    group: "Market Database",
    groupIcon: <DatabaseOutlined />,
    items: [
      { name: "Dashboard", path: "/dashboard", icon: <AppstoreOutlined /> },
      { name: "RouteToMarket", path: "/outlet", icon: <ApartmentOutlined /> },
      { name: "Geography", path: "/geography", icon: <EnvironmentOutlined /> },
    ],
  },
  {
    group: "Market Place",
    groupIcon: <ShoppingOutlined />,
    items: [
      { name: "Vendors", path: "/campaigns", icon: <ShopOutlined /> },
      { name: "Wholesalers", path: "/wholesaler", icon: <ShopOutlined /> },
      { name: "Integrations", path: "/commerce", icon: <ApiOutlined /> },
    ],
  },
  {
    group: "Sales-As-A-Service",
    groupIcon: <FaRegHandshake />,
    items: [
      { name: "Routes", path: "/agentRoutes", icon: <CompassOutlined /> },
      { name: "Telesales", path: "/calls", icon: <CustomerServiceOutlined /> },
      { name: "Broadcast", path: "/broadcast", icon: <SoundOutlined /> },
      { name: "Rider Portal", path: "/rider", icon: <MdElectricBike /> },
      {
        name: "Branch Portal",
        path: "/agentOrdersManager",
        icon: <ShoppingCartOutlined />,
      },
      {
        name: "Customer Analysis",
        path: "/customerAnalytics",
        icon: <PieChartOutlined />,
      },
      {
        name: "Rebates",
        path: "/rebate",
        icon: <MdCreditScore />,
      }
    ],
  },
  {
    group: "Sales-Operations",
    groupIcon: <BsBuildingGear />,
    items: [
      {
        name: "Orders Manager",
        path: "/orders",
        icon: <ShoppingCartOutlined />,
      },
      {
        name: "Delivery Schedule",
        path: "/schedule",
        icon: <ClockCircleOutlined />,
      },
      {
        name: "Manifest",
        path: "/manifest",
        icon: <LiaTruckLoadingSolid />,
      },
      {
        name: "Review Payments",
        path: "/reviewOrders",
        icon: <BsCashCoin />,
      },
      { name: "Stock Manager", path: "/stocks", icon: <InboxOutlined /> },
      { name: "Overview", path: "/orderAnalytics", icon: <PieChartOutlined /> },
      {
        name: "Agents Overview",
        path: "/agentPerformance",
        icon: <FaUsersGear />,
      },
      {
        name: "SKU Analysis",
        path: "/productPerformance",
        icon: <PieChartOutlined />,
      },

      {
        name: "Stock Analysis",
        path: "/stockAnalysis",
        icon: <BarChartOutlined />,
      },
    ],
  },
  {
    group: "Performance",
    groupIcon: <DashboardOutlined />,
    items: [
      { name: "Traction Dash", path: "/sales", icon: <DollarOutlined /> },
      { name: "Client Dash", path: "/onboarding", icon: <UserAddOutlined /> },
      { name: "TradeCalls Dash", path: "/tradeCalls", icon: <PhoneOutlined /> },
      { name: "Agents Dash", path: "/agentAnalytics", icon: <TeamOutlined /> },
      {
        name: "Telesales Dash",
        path: "/telesalesDash",
        icon: <CustomerServiceOutlined />,
      },
      {
        name: "FocusBrands Dash",
        path: "/focusBrands",
        icon: <StarOutlined />,
      },
      {
        name: "Fulfillment Dash",
        path: "/fulfillmentDash",
        icon: <CarOutlined />,
      },
      {
        name: "BrandIntelligence Dash",
        path: "/brandIntelligenceDash",
        icon: <BarChartOutlined />,
      },
      {
        name: "Broadcast Report",
        path: "/broadcastReport/:broadcastId",
        icon: <SoundOutlined />,
      },
    ],
  },

  {
    group: "Access Control",
    groupIcon: <TeamOutlined />,
    items: [
      { name: "Users", path: "/users", icon: <TeamOutlined /> },
      { name: "Riders", path: "/userRider", icon: <MdElectricBike /> },
      {
        name: "Observatory",
        path: "/observatory",
        icon: <ClockCircleOutlined />,
      },
      { name: "Settings", path: "/settings", icon: <SettingOutlined /> },
    ],
  },
];

export const FulfillmentCenterSideBarMenu = [
  {
    group: "",
    groupIcon: null,
    items: [
      { name: "Dashboard", path: "/clientHome", icon: <AppstoreOutlined /> },
    ],
  },
  {
    group: "Inventory",
    groupIcon: <InboxOutlined />,
    items: [
      { name: "Stock Level", path: "/stocks", icon: <InboxOutlined /> },
      { name: "SKUs", path: "/productPerformance", icon: <PieChartOutlined /> },
    ],
  },
  {
    group: "Performance",
    groupIcon: <RiseOutlined />,
    items: [
      { name: "Overview", path: "/orderAnalytics", icon: <PieChartOutlined /> },
      { name: "Traction", path: "/sales", icon: <DollarOutlined /> },
    ],
  },
  {
    group: "Settings",
    groupIcon: <SettingOutlined />,
    items: [{ name: "Settings", path: "/settings", icon: <SettingOutlined /> }],
  },
];

export const TdrSideBarMenu = [
  {
    group: "",
    groupIcon: null,
    items: [
      { name: "Dashboard", path: "/tdrHome", icon: <AppstoreOutlined /> },
    ],
  },
  {
    group: "Route Plan",
    groupIcon: <CompassOutlined />,
    items: [{ name: "Routes", path: "/taRoutes", icon: <CompassOutlined /> }],
  },
  {
    group: "Fulfilment",
    groupIcon: <ShoppingCartOutlined />,
    items: [
      {
        name: "Orders",
        path: "/agentOrdersManager",
        icon: <ShoppingCartOutlined />,
      },
    ],
  },
  {
    group: "Settings",
    groupIcon: <SettingOutlined />,
    items: [{ name: "Settings", path: "/settings", icon: <SettingOutlined /> }],
  },
];

export const TmmSideBarMenu = [
  {
    group: "",
    groupIcon: null,
    items: [
      { name: "Dashboard", path: "/tmmHome", icon: <AppstoreOutlined /> },
    ],
  },
  {
    group: "Fulfilment",
    groupIcon: <ShoppingCartOutlined />,
    items: [
      {
        name: "Orders",
        path: "/agentOrdersManager",
        icon: <ShoppingCartOutlined />,
      },
    ],
  },
  {
    group: "Settings",
    groupIcon: <SettingOutlined />,
    items: [{ name: "Settings", path: "/settings", icon: <SettingOutlined /> }],
  },
];

export const PartnerHomeMenu = [
  {
    group: "",
    groupIcon: null,
    items: [
      { name: "Dashboard", path: "/focusBrands", icon: <StarOutlined /> },
    ],
  },
  {
    group: "Settings",
    groupIcon: <SettingOutlined />,
    items: [{ name: "Settings", path: "/settings", icon: <SettingOutlined /> }],
  },
];

export const ClientManagerHomeMenu = [
  {
    group: "",
    groupIcon: null,
    items: [
      {
        name: "Dashboard",
        path: "/clientManagerHome",
        icon: <AppstoreOutlined />,
      },
    ],
  },
  {
    group: "Fulfilment",
    groupIcon: <ShoppingCartOutlined />,
    items: [
      { name: "Orders", path: "/clientOrders", icon: <ShoppingCartOutlined /> },
    ],
  },
  {
    group: "Settings",
    groupIcon: <SettingOutlined />,
    items: [{ name: "Settings", path: "/settings", icon: <SettingOutlined /> }],
  },
];

export const AgentManagerHomeMenu = [
  {
    group: "Home",
    groupIcon: <HomeOutlined />,
    items: [
      {
        name: "Dashboard",
        path: "/agentManagerHome",
        icon: <AppstoreOutlined />,
      },
    ],
  },
  {
    group: "Performance",
    groupIcon: <RiseOutlined />,
    items: [
      {
        name: "Agents Overview",
        path: "/agentPerformance",
        icon: <FaUsersGear />,
      },
      { name: "Overview", path: "/orderAnalytics", icon: <PieChartOutlined /> },
      { name: "Agents", path: "/agentAnalytics", icon: <TeamOutlined /> },
      { name: "TradeCalls", path: "/tradeCalls", icon: <PhoneOutlined /> },
      { name: "Focus Brands", path: "/focusBrands", icon: <StarOutlined /> },
    ],
  },
  {
    group: "Settings",
    groupIcon: <SettingOutlined />,
    items: [{ name: "Settings", path: "/settings", icon: <SettingOutlined /> }],
  },
];

export const RiderHomeMenu = [
  {
    group: "Home",
    groupIcon: <HomeOutlined />,
    items: [{ name: "Rider", path: "/rider", icon: <MdElectricBike /> }],
  },

  {
    group: "Settings",
    groupIcon: <SettingOutlined />,
    items: [{ name: "Settings", path: "/settings", icon: <SettingOutlined /> }],
  },
];

export const FulfillmentProviderHomeMenu = [
  {
    group: "Home",
    groupIcon: <HomeOutlined />,
    items: [
      {
        name: "Order Schedule",
        path: "/schedule",
        icon: <ClockCircleOutlined />,
      },
      {
        name: "Manifest",
        path: "/manifest",
        icon: <LiaTruckLoadingSolid />,
      },
      {
        name: "Fulfillment Dash",
        path: "/fulfillmentDash",
        icon: <CarOutlined />,
      },
      { name: "Overview", path: "/orderAnalytics", icon: <PieChartOutlined /> },
      {
        name: "Orders Manager",
        path: "/agentManagerHome",
        icon: <AppstoreOutlined />,
      },
    ],
  },
  {
    group: "Access Control",
    groupIcon: <SettingOutlined />,
    items: [
      { name: "Riders", path: "/userRider", icon: <MdElectricBike /> },
      { name: "Settings", path: "/settings", icon: <SettingOutlined /> },
    ],
  },
];

// ---------------------------------------------------------------------------
// Role → menu lookup
// ---------------------------------------------------------------------------
export const ROLE_MENU_MAP = {
  tdr: TdrSideBarMenu,
  tmm: TmmSideBarMenu,
  client: FulfillmentCenterSideBarMenu,
  clientManager: ClientManagerHomeMenu,
  agentManager: AgentManagerHomeMenu,
  partner: PartnerHomeMenu,
  rider: RiderHomeMenu,
  fulfillmentProvider: FulfillmentProviderHomeMenu,
  // admin → falls through to AdminSideBarMenu (default)
};

// ---------------------------------------------------------------------------
// Sentinel keys for non-navigation menu actions
// ---------------------------------------------------------------------------
export const MENU_ACTION_KEYS = {
  LOGOUT: "__logout__",
  INSTALL: "__install__",
};

// ---------------------------------------------------------------------------
// Utility: grouped menu data → Ant Design Menu `items` array
//
// Groups with a label  → collapsible SubMenu  (key: "sub_<GroupName>")
// Groups without label → flat top-level items (no header, no toggle)
// Logout / Install     → flat items after a divider (always accessible)
// ---------------------------------------------------------------------------

/**
 * @param {Array}   menuGroups  - One of the *SideBarMenu arrays above
 * @param {boolean} canInstall  - Whether to show the PWA install action
 * @returns {import('antd').MenuProps['items']}
 */
export const buildAntdMenuItems = (menuGroups, canInstall = false) => {
  const navItems = menuGroups.flatMap((group) => {
    const children = group.items.map((item) => ({
      key: item.path,
      icon: item.icon,
      label: item.name,
    }));

    // No label → flat top-level items (e.g. the Dashboard row)
    if (!group.group) return children;

    // Has label → collapsible submenu
    return {
      key: `sub_${group.group}`,
      icon: group.groupIcon,
      label: group.group,
      children,
    };
  });

  return [
    ...navItems,
    { type: "divider" },
    ...(canInstall
      ? [
          {
            key: MENU_ACTION_KEYS.INSTALL,
            icon: <DownloadOutlined />,
            label: "Install App",
          },
        ]
      : []),
    {
      key: MENU_ACTION_KEYS.LOGOUT,
      icon: <LogoutOutlined />,
      label: "Log Out",
      danger: true,
    },
  ];
};

// ---------------------------------------------------------------------------
// Helper: returns the submenu key(s) that contain the current path
// Used to seed `defaultOpenKeys` in the Menu so the active section is open.
// ---------------------------------------------------------------------------
export const getDefaultOpenKeys = (menuGroups, pathname) =>
  menuGroups
    .filter((g) => g.group && g.items.some((item) => item.path === pathname))
    .map((g) => `sub_${g.group}`);
